import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="notFound text-center  d-flex align-items-center justify-content-center">
            <h1>404 Not Found</h1>
        </div>
    );
};

export default NotFound;